import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Panel } from '@/components/Panel';
import { toast } from 'sonner';
import { Check } from 'lucide-react';

export default function AdminPayouts() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get('/admin/payouts'); setRows(data.payouts || []); }
    catch { toast.error('Failed to load'); } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const markPaid = async (p) => {
    const notes = window.prompt(`Reference / notes for this payout (optional):`, '');
    if (notes === null) return;
    try { await api.post(`/admin/payouts/${p.id}/mark-paid`, { notes }); toast.success('Marked paid'); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Failed'); }
  };

  return (
    <div className="space-y-5" data-testid="admin-payouts">
      <div className="h-panel-thin p-6">
        <div className="h-eyebrow">Ambassadors</div>
        <div className="h-display text-4xl mt-1" style={{ color: 'var(--heritage-plum)' }}>Ambassador Payouts</div>
        <p className="text-sm opacity-85 mt-1" style={{ color: 'var(--heritage-plum)' }}>Requests from ambassadors for the commission they've earned. Mark paid once you've transferred.</p>
      </div>
      {loading && <div className="h-eyebrow">Loading…</div>}
      {!loading && rows.length === 0 && <Panel className="p-8 text-center"><div className="h-serif text-xl" style={{ color: 'var(--heritage-plum)' }}>No payout requests yet</div></Panel>}
      <div className="space-y-2">
        {rows.map((p) => (
          <Panel key={p.id} className="p-4 flex items-center justify-between gap-3 flex-wrap" data-testid={`payout-${p.id}`}>
            <div>
              <div className="h-serif text-lg" style={{ color: 'var(--heritage-plum)' }}>{p.ambassador_name}</div>
              <div className="text-xs opacity-75" style={{ color: 'var(--heritage-plum)' }}>Requested {new Date(p.requested_at).toLocaleString('en-NZ')}{p.paid_at ? ` · Paid ${new Date(p.paid_at).toLocaleDateString('en-NZ')}` : ''}</div>
              {p.notes && <div className="text-xs italic opacity-70 mt-1" style={{ color: 'var(--heritage-plum)' }}>{p.notes}</div>}
            </div>
            <div className="flex items-center gap-3">
              <div className="h-display text-2xl" style={{ color: 'var(--heritage-plum)' }}>${Number(p.amount).toFixed(2)}</div>
              <span className="h-chip text-[9px]" style={{ background: p.status === 'paid' ? 'rgba(91,110,44,0.18)' : 'rgba(75,24,56,0.08)', borderColor: 'transparent', color: 'var(--heritage-plum)' }}>{(p.status || 'pending').toUpperCase()}</span>
              {p.status !== 'paid' && <button onClick={() => markPaid(p)} className="h-btn text-xs" data-testid={`payout-mark-paid-${p.id}`}><Check size={12} className="mr-1" /> Mark paid</button>}
            </div>
          </Panel>
        ))}
      </div>
    </div>
  );
}
